import {useMemo} from 'react';

import {ItemForecastInterface} from '../../../interfaces/weather/ForecastWeatherInterface';

export const useForecastIcon = (forecast?: ItemForecastInterface) => {
  return useMemo(() => forecast ? forecast?.weather[0].icon : undefined, [forecast]);
};
